import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { translate } from '../../../../base/i18n';
import {
    bindConFeeOrderItem,
    bindConvenienceFeeSelected,
    bindDefaultDonationAmount,
    bindDonationAmountIndex,
    bindDonationAmountSelected,
    bindDonationOrderItems,
    bindFinalDonationAmount,
    bindFinalDonationAmountError,
    bindInstallements,
    bindInstallmentChargeValue,
    bindIsDonationAmountEmpty,
    bindIsInDefiniteRecurring,
    bindMeetFormData,
    bindMultiDonationError,
    bindMultiDonationOrderItems,
    bindMultiDonationVals,
    bindMultiPayTotalTaxDeduct,
    bindOtherAmountMinMaxError
} from '../../../actions';
import {
    CalcConvenienceFee as calcConvenienceFee,
    calculateEndPeriod,
    getButtonRowVal,
    getButtonStyles,
    getDecimalPoint,
    getPaymentAmount,
    getRemovedFee,
    getTaxDeductableAmount,
    removedecimal
} from '../utility/util';

const DonationsButton = ({ t, ...props }) => {
    const meetformData = useSelector(
        state => state['features/clickandpledge']?.meetFormData || {}
    );
    const installments = useSelector(
        state => state['features/clickandpledge']?.installementSelected || ''
    );
    const recurringselection = useSelector(
        state => state['features/clickandpledge']?.recurringSelection || ''
    );
    const convFee = useSelector(
        state => state['features/clickandpledge']?.convenienceFeeAmount || ''
    );
    const multiDonationVal = useSelector(
        state => state['features/clickandpledge']?.multiDonationVals || {}
    );

    const formSettings = useSelector(
        state => state['features/clickandpledge']?.formSettings || {}
    );
    const showoneTimePayOption = useSelector(
        state => state['features/clickandpledge']?.showoneTimePayOption || false
    );
    const amountButtonSection = useSelector(
        state => state['features/clickandpledge']?.amountSection || []
    );

    const donationamount = useSelector(
        state => state['features/clickandpledge']?.donationAmountSelected || ''
    );
    const multiDonOrderItems = useSelector(
        state => state['features/clickandpledge']?.multiDonationOrderItems || []
    );

    const donationErr = useSelector(
        state => state['features/clickandpledge']?.multiDonationErr || ''
    );
    const IsDonationAmountEmpty = useSelector(
        state => state['features/clickandpledge']?.isDonationAmountEmpty || false
    );

    const convfeeSelec = useSelector(
        state => state['features/clickandpledge']?.convenienceFeeSection || {}
    );
    const IsConvFeeSelected = useSelector(
        state => state['features/clickandpledge']?.convenienceFeeSelected || false
    );
    const finalDonationAmountError = useSelector(
        state => state['features/clickandpledge']?.finalDonationAmountError || false
    );
    const IsInDefiniteRecurring = useSelector(
        state => state['features/clickandpledge']?.isIndefiniteRecurring || false
    );
    const isInstallmentTouched = useSelector(
        state => state['features/clickandpledge']?.isInstallmentTouched || false
    );
    const recurringMethods = useSelector(
        state => state['features/clickandpledge']?.recurringMethod || ''
    );
    const noofperiodicity = useSelector(
        state => state['features/clickandpledge']?.noofperiodicity || ''
    );
    const periodicityEndDate = useSelector(
        state => state['features/clickandpledge']?.periodicityEndDate || ''
    );
    const donationIndex = useSelector(
        state => state['features/clickandpledge']?.donationAmountIndex || null
    );

    const amountStyles = getButtonStyles(
        formSettings.AmountButtonSettings && formSettings.AmountButtonSettings.FB_Buttons
    );
    const amountSelectedStyles = getButtonStyles(
        formSettings.AmountButtonSettings && formSettings.AmountButtonSettings.FB_selectedButtons
    );

    const [ multiDonationAmt, setMultiDonationAmt ] = useState({});
    const [ multiMinMaxErr, setMultiMinMaxErr ] = useState({});
    const [ otherMinMax, setOtherMinMax ] = useState('');
    const [ recurringPeriodicityEndDate, setRecurringPeriodicityEndDate ] = useState('');
    const prevRecurringSelection = useRef();
    const prevItemListRef = useRef();
    const meetformDataRef = useRef(meetformData);

    useEffect(() => {
        meetformDataRef.current = meetformData;
    }, [ meetformData ]);

    const dispatch = useDispatch();

    const rValue = useMemo(() => {
        if (meetformData.formdata) {
            return meetformData.formdata.find(obj => obj.amountsection !== undefined);
        }

        return null;
    }, [ meetformData.formdata ]);

    // Memoize expensive calculations
    const calculatedRowVal = useMemo(() => {
        let rowVal = getButtonRowVal(
            formSettings.AmountButtonSettings && formSettings.AmountButtonSettings.FB_amountbtn_RowVal
        );

        const isBoost = Boolean(
            sessionStorage.getItem('boostClicked') === 'true'
            || sessionStorage.getItem('seedAmount')
            || sessionStorage.getItem('currentBoostStep')
            || sessionStorage.getItem('boostUp')
        );

        if (isBoost && amountButtonSection && amountButtonSection.DonationItemList
            && amountButtonSection.DonationItemList.length) {
            rowVal = rowVal === 4 && amountButtonSection.DonationItemList.length < rowVal
                ? amountButtonSection.DonationItemList.length : rowVal;
        }

        return rowVal;
    }, [ formSettings.AmountButtonSettings, amountButtonSection.DonationItemList ]);


    const onDonationChange = useCallback((donationAmount, index, item) => {
        let addFee = convFee;
        let convfeeSelect = false;
        const shouldUseDefaultInstallments = (Boolean(installments) === false)
            && (isInstallmentTouched === false)
            && (IsInDefiniteRecurring === false)
            && recurringPeriodicityEndDate !== 1
            && recurringMethods !== 'Subscription';
        let installmnts = shouldUseDefaultInstallments ? 2 : installments;

        const endDate = new Date(periodicityEndDate).getFullYear();

        if (endDate !== 1 && recurringMethods !== 'Subscription') {
            const boostUpVals = JSON.parse(sessionStorage.getItem('boostUp'));

            if (boostUpVals !== null) {
                const calperiod = calculateEndPeriod(recurringMethods, periodicityEndDate, recurringselection);

                if (calperiod && calperiod.data.toString().length <= 3) {
                    installmnts = calperiod.data;

                    if (donationAmount < installmnts) {
                        installmnts = donationAmount;
                    }
                }
            }
        }

        if (IsConvFeeSelected || convfeeSelec.DefaultOpt === '1' || convfeeSelec.AddAdditionalFeeType === '1') {
            const isNonSubscriptionInstallment = recurringMethods !== 'Subscription' && installmnts;
            const donAmt = isNonSubscriptionInstallment
                ? getDecimalPoint(donationAmount, installmnts, '')
                : parseFloat(donationAmount);
            const calFee = calcConvenienceFee(
                donAmt,
                convfeeSelec.AdditionalFeePercentage,
                convfeeSelec.AdditionalFeeAmount,
                installmnts,
                recurringselection,
                convfeeSelec.AdjustFee,
                recurringMethods
            );

            convfeeSelect = true;
            addFee = calFee;
            dispatch(bindConvenienceFeeSelected(true));
        }

        let DonAmount = getPaymentAmount(
            donationAmount,
            installmnts,
            addFee,
            convfeeSelect,
            recurringMethods,
            recurringselection
        );

        DonAmount = donationAmount === -1 ? -1 : removedecimal(DonAmount);
        const processedAmount = donationAmount === -1 ? -1 : removedecimal(donationAmount);

        DonAmount = convfeeSelect && isInstallmentTouched === false && DonAmount !== -1
            ? getRemovedFee(DonAmount, addFee) : DonAmount;

        dispatch(
            bindMeetFormData({
                formdata: meetformData.formdata
                    ? meetformData.formdata.map(q => {
                        return {
                            ...q,
                            amountsection: recurringMethods === 'Subscription' ? processedAmount : DonAmount,
                            other_amount: ''
                        };
                    })
                    : [ {
                        other_amount: '',
                        amountsection: recurringMethods === 'Subscription' ? processedAmount : DonAmount
                    } ]
            })
        );

        dispatch(bindIsDonationAmountEmpty(false));

        // This is for default other value
        if ((item.DonationFor === 'Other' || item.Type === 'Open')
            && item.DefaultValue > 0) {
            const boostUpVals = JSON.parse(sessionStorage.getItem('boostUp'));
            const minVal = boostUpVals !== null && Object.keys(boostUpVals).length
                ? boostUpVals.minAmountVal : item.MinValue;
            const maxVal = boostUpVals !== null && Object.keys(boostUpVals).length
                ? boostUpVals.maxAmountVal : item.MaxValue;

            const amt = (donationAmount < 0 || !donationAmount) && item.DefaultValue > 0
                ? item.DefaultValue : donationAmount;

            if (minVal > 0 && amt > 0 && amt < minVal) {
                dispatch(bindOtherAmountMinMaxError(true));
                setOtherMinMax(t('clickandpledge.minimumLimitIs', {
                    currency: formSettings.Currency,
                    value: minVal
                }));
            } else if (maxVal > 0 && amt > 0 && amt > maxVal) {
                dispatch(bindOtherAmountMinMaxError(true));
                setOtherMinMax(t('clickandpledge.maximumLimitIs', {
                    currency: formSettings.Currency,
                    value: maxVal
                }));
            } else {
                dispatch(bindOtherAmountMinMaxError(false));
                setOtherMinMax('');
            }

            let otherAddFee = convFee;

            if (IsConvFeeSelected || convfeeSelec.DefaultOpt === '1'
                || convfeeSelec.AddAdditionalFeeType === '1') {
                const isNonSubscriptionInstallment = recurringMethods !== 'Subscription' && installmnts;
                const donAmt = isNonSubscriptionInstallment
                    ? getDecimalPoint(item.DefaultValue, installmnts, '')
                    : parseFloat(item.DefaultValue);
                const calFee = calcConvenienceFee(
                    donAmt,
                    convfeeSelec.AdditionalFeePercentage,
                    convfeeSelec.AdditionalFeeAmount,
                    installmnts,
                    recurringselection,
                    convfeeSelec.AdjustFee,
                    recurringMethods
                );

                convfeeSelect = true;
                otherAddFee = calFee;
                dispatch(bindConvenienceFeeSelected(true));
            }

            const DonOtAmount = getPaymentAmount(
                item.DefaultValue,
                installments,
                otherAddFee,
                convfeeSelect,
                recurringMethods,
                recurringselection
            );

            dispatch(bindDonationAmountSelected(item.DefaultValue));
            dispatch(bindDonationAmountIndex(item.ItemID));
            dispatch(bindFinalDonationAmount(DonOtAmount));
            dispatch(bindDefaultDonationAmount(item.DefaultValue));
            dispatch(
                bindMeetFormData({
                    formdata: meetformData.formdata
                        ? meetformData.formdata.map(q => {
                            return {
                                ...q,
                                amountsection: -1,
                                other_amount: item.DefaultValue
                            };
                        })
                        : [ {
                            other_amount: item.DefaultValue,
                            amountsection: -1
                        } ]
                })
            );

            const taxDeductibleOther = recurringMethods === 'Subscription'
                ? getTaxDeductableAmount(
                    item.DefaultValue,
                    formSettings.TaxDeductible ? item.TaxDeductible : 0,
                    item.FMV
                )
                : getTaxDeductableAmount(
                    DonOtAmount,
                    formSettings.TaxDeductible ? item.TaxDeductible : 0,
                    item.FMV
                );

            dispatch(bindDonationOrderItems({
                itemId: item.ItemID,
                dItemName: item.ItemName,
                dsku: item.SKU,
                dgau: item.GAU,
                fmv: item.FMV,
                taxDeductible: taxDeductibleOther,
                taxPercentage: item.TaxDeductible
            }));
        } else if (donationAmount === -1) {
            dispatch(bindDonationAmountIndex(item.ItemID));
            dispatch(bindDonationAmountSelected(-1));
            dispatch(bindFinalDonationAmount(0));
            dispatch(bindDefaultDonationAmount(-1));
            dispatch(bindDonationOrderItems({
                itemId: item.ItemID,
                dItemName: item.ItemName || t('clickandpledge.generalDonation'),
                dsku: item.SKU || '',
                dgau: item.GAU || '',
                fmv: item.FMV || 0,
                taxDeductible: 0,
                taxPercentage: formSettings.TaxDeductible ? item.TaxDeductible || 0 : 0
            }));
            dispatch(
                bindMeetFormData({
                    formdata: meetformData.formdata
                        ? meetformData.formdata.map(q => {
                            return {
                                ...q,
                                amountsection: -1,
                                other_amount: ''
                            };
                        })
                        : [ {
                            other_amount: '',
                            amountsection: -1
                        } ]
                })
            );
        } else {
            dispatch(bindDonationAmountIndex(item.ItemID));
            dispatch(bindDonationAmountSelected(processedAmount));
            dispatch(bindFinalDonationAmount(DonAmount));
            dispatch(bindDefaultDonationAmount(0));

            if (processedAmount > 0) {
                const taxDeductibleRegular = recurringMethods === 'Subscription'
                    ? getTaxDeductableAmount(
                        processedAmount,
                        formSettings.TaxDeductible ? item.TaxDeductible : 0,
                        item.FMV
                    )
                    : getTaxDeductableAmount(
                        DonAmount,
                        formSettings.TaxDeductible ? item.TaxDeductible : 0,
                        item.FMV
                    );

                dispatch(bindDonationOrderItems({
                    itemId: item.ItemID,
                    dItemName: item.ItemName,
                    dsku: item.SKU,
                    dgau: item.GAU,
                    fmv: item.FMV,
                    taxDeductible: taxDeductibleRegular,
                    taxPercentage: item.TaxDeductible
                }));
            }
        }

        if (otherMinMax) {
            dispatch(bindOtherAmountMinMaxError(false));
            setOtherMinMax('');
        }

        dispatch(bindInstallmentChargeValue(0));
        dispatch(bindFinalDonationAmountError(false));

        if (DonAmount !== -1 && recurringMethods !== 'Subscription') {
            dispatch(bindInstallmentChargeValue(DonAmount));
        }
    }, [
        convFee,
        installments,
        isInstallmentTouched,
        IsInDefiniteRecurring,
        recurringPeriodicityEndDate,
        recurringMethods,
        periodicityEndDate,
        recurringselection,
        IsConvFeeSelected,
        convfeeSelec.DefaultOpt,
        convfeeSelec.AddAdditionalFeeType,
        convfeeSelec.AdditionalFeePercentage,
        convfeeSelec.AdditionalFeeAmount,
        convfeeSelec.AdjustFee,
        meetformData.formdata,
        formSettings.Currency,
        formSettings.TaxDeductible,
        otherMinMax,
        dispatch,
        t
    ]);

    // Split the massive useEffect into smaller, focused ones
    useEffect(() => {
        const isRecurringChanged = prevRecurringSelection.current !== recurringselection;
        const isItemListChanged = prevItemListRef.current !== amountButtonSection.DonationItemList;

        if (recurringselection && !props.isDonePayment && (isRecurringChanged || isItemListChanged)) {
            props.amountValidator.current.hideMessages();
            props.amountValidator.current.hideMessageFor('other_amount');

            setRecurringPeriodicityEndDate(new Date(periodicityEndDate).getFullYear());
            dispatch(bindIsInDefiniteRecurring(false));
            dispatch(bindFinalDonationAmountError(false));
            setOtherMinMax('');

            const defaultItemIndex = amountButtonSection.DonationItemList?.findIndex(
                item => item.DefaultSelection === true || item.DefaultSelection === 'true' || item.DefaultSelection === 'True'
            );
            const defaultItem = defaultItemIndex !== undefined && defaultItemIndex !== -1
                ? amountButtonSection.DonationItemList[defaultItemIndex]
                : null;

            if (defaultItem) {
                onDonationChange(
                    defaultItem.DonationFor === 'Other' || defaultItem.Type === 'Open'
                        ? -1
                        : defaultItem.DefaultValue,
                    defaultItemIndex,
                    defaultItem
                );
            } else {
                dispatch(bindDonationAmountIndex(null));
                dispatch(bindDonationAmountSelected(''));
                dispatch(bindFinalDonationAmount(''));
                dispatch(bindDefaultDonationAmount(''));
                dispatch(bindIsDonationAmountEmpty(true));
                dispatch(bindDonationOrderItems({}));
                dispatch(
                    bindMeetFormData({
                        formdata: meetformDataRef.current?.formdata
                            ? meetformDataRef.current.formdata.map(q => {
                                return {
                                    ...q,
                                    amountsection: '',
                                    other_amount: ''
                                };
                            })
                            : [ {
                                other_amount: '',
                                amountsection: ''
                            } ]
                    })
                );
            }

            prevRecurringSelection.current = recurringselection;
            prevItemListRef.current = amountButtonSection.DonationItemList;
        }
    }, [ recurringselection, periodicityEndDate, dispatch, props.amountValidator, props.isDonePayment, amountButtonSection.DonationItemList, onDonationChange ]);

    // Handle indefinite recurring logic
    useEffect(() => {
        if (recurringselection && noofperiodicity >= 998 && recurringselection !== 'One Time Only') {
            dispatch(bindIsInDefiniteRecurring(true));
            dispatch(bindInstallements(''));
        }
    }, [ recurringselection, noofperiodicity, dispatch ]);

    // Handle convenience fee logic
    useEffect(() => {
        if (recurringselection && !IsConvFeeSelected) {
            dispatch(bindConFeeOrderItem({}));
        }
    }, [ recurringselection, IsConvFeeSelected, dispatch ]);

    // Handle payment completion
    useEffect(() => {
        if (props.isDonePayment) {
            props.callbackOnPaymentDone();
        }
    }, [ props.isDonePayment, props.callbackOnPaymentDone ]);

    useEffect(() => {
        if (showoneTimePayOption) {
            dispatch(
                bindMeetFormData({
                    formdata: meetformData.formdata
                        ? meetformData.formdata.map(q => {
                            return {
                                ...q,
                                amountsection: -1,
                                other_amount: ''
                            };
                        })
                        : [ {
                            amountsection: -1,
                            other_amount: ''
                        } ]
                })
            );
        }
    }, [ showoneTimePayOption, dispatch, meetformData ]);

    useEffect(() => {
        if (convfeeSelec && (convfeeSelec.AddAdditionalFeeType === '1' || convfeeSelec.DefaultOpt === '1')) {
            dispatch(bindConvenienceFeeSelected(true));
        }
    }, [ convfeeSelec, recurringselection, dispatch ]);


    const onOtherDonation = useCallback(e => {
        const regex = /^\d*\.?\d{0,2}$/;
        const OtherVal = e.target.value;

        if (!regex.test(OtherVal)) {
            return;
        }

        const shouldUseDefaultInstallments = (Boolean(installments) === false)
            && (isInstallmentTouched === false)
            && (IsInDefiniteRecurring === false)
            && recurringPeriodicityEndDate !== 1
            && recurringMethods !== 'Subscription';
        let installmnts = shouldUseDefaultInstallments ? 2 : installments;
        const endDate = new Date(periodicityEndDate).getFullYear();

        if (endDate !== 1 && recurringMethods !== 'Subscription') {
            const boostUpVals = JSON.parse(sessionStorage.getItem('boostUp'));

            if (boostUpVals !== null) {
                const calperiod = calculateEndPeriod(recurringMethods, periodicityEndDate, recurringselection);

                if (calperiod && calperiod.data.toString().length <= 3) {
                    installmnts = calperiod.data;

                    if (OtherVal < installmnts) {
                        installmnts = OtherVal;
                    }
                }
            }
        }

        let addFee = convFee;
        let convfeeSelect = false;

        if (IsConvFeeSelected || convfeeSelec.DefaultOpt === '1' || convfeeSelec.AddAdditionalFeeType === '1') {
            const isNonSubscriptionInstallment = recurringMethods !== 'Subscription' && installmnts;
            const donAmt = isNonSubscriptionInstallment
                ? getDecimalPoint(OtherVal, installmnts, '')
                : parseFloat(OtherVal);
            const calFee = calcConvenienceFee(
                donAmt,
                convfeeSelec.AdditionalFeePercentage,
                convfeeSelec.AdditionalFeeAmount,
                installmnts,
                recurringselection,
                convfeeSelec.AdjustFee,
                recurringMethods
            );

            addFee = calFee;
            convfeeSelect = true;
            dispatch(bindConvenienceFeeSelected(true));
        }

        let DonOthAmount = getPaymentAmount(
            OtherVal,
            installmnts,
            addFee,
            convfeeSelect,
            recurringMethods,
            recurringselection
        );

        DonOthAmount = convfeeSelect && isInstallmentTouched === false
            ? getRemovedFee(DonOthAmount, addFee)
            : DonOthAmount;

        dispatch(
            bindMeetFormData({
                formdata: meetformData.formdata
                    ? meetformData.formdata.map(q => {
                        return {
                            ...q,
                            amountsection: -1,
                            other_amount: recurringMethods === 'Subscription' ? OtherVal : DonOthAmount
                        };
                    })
                    : [ {
                        amountsection: -1,
                        other_amount: recurringMethods === 'Subscription' ? OtherVal : DonOthAmount
                    } ]
            })
        );

        const boostUpVals = JSON.parse(sessionStorage.getItem('boostUp'));
        const defaultOtherData = (amountButtonSection.DonationItemList || []).filter(
            arr => arr.DonationFor === 'Other' || arr.Type === 'Open'
        );
        const baseMin = defaultOtherData[0]?.MinValue ?? 0;
        const baseMax = defaultOtherData[0]?.MaxValue ?? 0;
        const minVal = boostUpVals && Object.keys(boostUpVals).length
            ? parseFloat(boostUpVals.minAmountVal) || parseFloat(baseMin) || 0
            : parseFloat(baseMin) || 0;
        const maxVal = boostUpVals && Object.keys(boostUpVals).length
            ? parseFloat(boostUpVals.maxAmountVal) || parseFloat(baseMax) || 0
            : parseFloat(baseMax) || 0;
        const numVal = parseFloat(OtherVal);

        if (!isNaN(numVal) && numVal > 0) {
            if (minVal > 0 && numVal < minVal) {
                dispatch(bindOtherAmountMinMaxError(true));
                setOtherMinMax(t('clickandpledge.minimumLimitIs', {
                    currency: formSettings.Currency,
                    value: minVal
                }));
            } else if (maxVal > 0 && numVal > maxVal) {
                dispatch(bindOtherAmountMinMaxError(true));
                setOtherMinMax(t('clickandpledge.maximumLimitIs', {
                    currency: formSettings.Currency,
                    value: maxVal
                }));
            } else {
                dispatch(bindOtherAmountMinMaxError(false));
                setOtherMinMax('');
            }
        } else {
            dispatch(bindOtherAmountMinMaxError(false));
            setOtherMinMax('');
        }

        dispatch(bindDonationAmountSelected(OtherVal));
        dispatch(bindDefaultDonationAmount(0));
        dispatch(bindFinalDonationAmount(DonOthAmount));

        if (recurringMethods !== 'Subscription') {
            dispatch(bindInstallmentChargeValue(DonOthAmount));
        }

        dispatch(bindIsDonationAmountEmpty(false));
        dispatch(bindFinalDonationAmountError(false));

        if (showoneTimePayOption) {
            dispatch(bindDonationOrderItems({
                dItemName: t('clickandpledge.generalDonation'),
                dsku: '',
                dgau: '',
                fmv: 0,
                taxDeductible: 0,
                taxPercentage: 0
            }));
        } else {
            const otherItem = (amountButtonSection.DonationItemList || []).find(
                itm => itm.DonationFor === 'Other' || itm.Type === 'Open'
            ) || (amountButtonSection.DonationItemList && amountButtonSection.DonationItemList[0]) || {};

            const taxDeductiblePct = formSettings.TaxDeductible ? otherItem.TaxDeductible || 0 : 0;
            const itemFMV = otherItem.FMV || 0;

            const taxDeductibleOtherDonation = recurringMethods === 'Subscription'
                ? getTaxDeductableAmount(
                    OtherVal,
                    taxDeductiblePct,
                    itemFMV
                )
                : getTaxDeductableAmount(
                    DonOthAmount,
                    taxDeductiblePct,
                    itemFMV
                );

            dispatch(bindDonationOrderItems({
                itemId: otherItem.ItemID,
                dItemName: otherItem.ItemName || t('clickandpledge.generalDonation'),
                dsku: otherItem.SKU || '',
                dgau: otherItem.GAU || '',
                fmv: itemFMV,
                taxDeductible: taxDeductibleOtherDonation,
                taxPercentage: taxDeductiblePct
            }));
        }
    }, [
        installments,
        isInstallmentTouched,
        IsInDefiniteRecurring,
        recurringPeriodicityEndDate,
        recurringMethods,
        periodicityEndDate,
        recurringselection,
        convFee,
        IsConvFeeSelected,
        convfeeSelec.DefaultOpt,
        convfeeSelec.AddAdditionalFeeType,
        convfeeSelec.AdditionalFeePercentage,
        convfeeSelec.AdditionalFeeAmount,
        convfeeSelec.AdjustFee,
        meetformData.formdata,
        showoneTimePayOption,
        amountButtonSection.DonationItemList,
        formSettings.Currency,
        formSettings.TaxDeductible,
        dispatch,
        t
    ]);

    const multiPaymentOnChange = useCallback(e => {
        const regex = /^[0-9]*\.?[0-9]*$/;
        const multiVal = e.target.value.toString()
            .split('.')
            .map((el, mapIndex) => {
                if (mapIndex) {
                    return el.split('').slice(0, 2)
                        .join('');
                }

                return el;
            })
            .join('.');

        if (!regex.test(multiVal)) {
            return;
        }

        const newMultiDonationAmt = {
            ...multiDonationAmt,
            [e.target.name]: multiVal === '' ? 0 : removedecimal(multiVal)
        };

        setMultiDonationAmt(newMultiDonationAmt);
        dispatch(bindMultiDonationVals(newMultiDonationAmt));
    }, [ multiDonationAmt, dispatch ]);

    const multiPaymentBlur = useCallback((e, item) => {
        const total = Object.keys(multiDonationAmt).length && Object.values(multiDonationAmt).reduce(
            (k, n) => parseFloat(k) + parseFloat(n)
        );

        let addFee = convFee;
        let convfeeSelect = false;
        const shouldUseDefaultInstallments = (Boolean(installments) === false)
            && (isInstallmentTouched === false)
            && (IsInDefiniteRecurring === false)
            && recurringPeriodicityEndDate !== 1
            && recurringMethods !== 'Subscription';
        const installmnts = shouldUseDefaultInstallments ? 2 : installments;

        if (IsConvFeeSelected || convfeeSelec.DefaultOpt === '1' || convfeeSelec.AddAdditionalFeeType === '1') {
            const isNonSubscriptionInstallment = recurringMethods !== 'Subscription' && installmnts;
            const donAmt = isNonSubscriptionInstallment
                ? getDecimalPoint(total, installmnts, '')
                : parseFloat(total);
            const calFee = calcConvenienceFee(
                donAmt,
                convfeeSelec.AdditionalFeePercentage,
                convfeeSelec.AdditionalFeeAmount,
                installmnts,
                recurringselection,
                convfeeSelec.AdjustFee,
                recurringMethods
            );

            addFee = calFee;
            convfeeSelect = true;
            dispatch(bindConvenienceFeeSelected(true));
        }

        const Damount = getPaymentAmount(
            total,
            installmnts,
            addFee,
            convfeeSelect,
            recurringMethods,
            recurringselection
        );

        dispatch(
            bindMeetFormData({
                formdata: meetformData.formdata
                    ? meetformData.formdata.map(q => {
                        return {
                            ...q,
                            recurrings: recurringselection,
                            amountsection: recurringMethods === 'Subscription'
                                ? total : removedecimal(Damount)
                        };
                    })
                    : [ {
                        amountsection: recurringMethods === 'Subscription'
                            ? total : removedecimal(Damount)
                    } ]
            })
        );

        if (recurringMethods !== 'Subscription') {
            dispatch(bindInstallmentChargeValue(removedecimal(Damount)));
        }

        dispatch(bindDonationAmountSelected(removedecimal(total)));
        dispatch(bindFinalDonationAmount(removedecimal(Damount)));
        dispatch(bindDefaultDonationAmount(0));
        dispatch(bindFinalDonationAmountError(false));

        if (item.MinValue > 0 && parseFloat(e.target.value) < item.MinValue) {
            dispatch(
                bindMultiDonationError(t('clickandpledge.minimumLimitIs', {
                    currency: formSettings.Currency,
                    value: item.MinValue
                }))
            );
            setMultiMinMaxErr({
                ...multiMinMaxErr,
                [e.target.name]: t('clickandpledge.minimumLimitIs', {
                    currency: formSettings.Currency,
                    value: item.MinValue
                })
            });
            sessionStorage.setItem('multiError', true);
        } else if (Object.keys(multiMinMaxErr).length
            && Object.prototype.hasOwnProperty.call(multiMinMaxErr, e.target.name)) {
            delete multiMinMaxErr[e.target.name];
        }

        if (item.MaxValue > 0 && parseFloat(e.target.value) > item.MaxValue) {
            dispatch(
                bindMultiDonationError(t('clickandpledge.maximumLimitIs', {
                    currency: formSettings.Currency,
                    value: item.MaxValue
                }))
            );
            setMultiMinMaxErr({
                ...multiMinMaxErr,
                [e.target.name]: t('clickandpledge.maximumLimitIs', {
                    currency: formSettings.Currency,
                    value: item.MaxValue
                })
            });
            sessionStorage.setItem('multiError', true);
        } else if (Object.keys(multiMinMaxErr).length
            && Object.prototype.hasOwnProperty.call(multiMinMaxErr, e.target.name)) {
            delete multiMinMaxErr[e.target.name];
        }

        const keys = Object.keys(multiMinMaxErr);

        if (keys.length) {
            dispatch(bindMultiDonationError(multiMinMaxErr[keys[0]]));
            sessionStorage.setItem('multiError', true);
        } else {
            sessionStorage.setItem('multiError', false);
        }

        if (e.target.value.length < item.MinValue) {
            dispatch(
                bindMultiDonationError(t('clickandpledge.pleaseEnterAtleastValues', { value: item.MinValue }))
            );
        }

        if (item.MaxValue > 0 && e.target.value.length > item.MaxValue) {
            dispatch(
                bindMultiDonationError(
                    t('clickandpledge.amountShouldNotBeMoreThanValues', { value: item.MaxValue })
                )
            );
        }

        if (!Damount || Damount === 0) {
            dispatch(bindMultiDonationError(t('clickandpledge.amountShouldNotBeEmpty')));
        } else {
            dispatch(bindMultiDonationError(''));
        }

        props.amountValidator.current.showMessageFor([ e.target.name ]);
        let newVal = e.target.value;

        if (isNaN(Number(newVal)) || newVal === '') {
            newVal = 0;
        }

        const newMultiOrderState = multiDonOrderItems.length && multiDonOrderItems.map(obj => {
            const newObj = { ...obj };

            return newObj.dItemName === item.ItemName
                ? {
                    ...newObj,
                    dItemPrice: parseFloat(removedecimal(newVal)),
                    taxDeductible: getTaxDeductableAmount(
                        newVal,
                        formSettings.TaxDeductible ? item.TaxDeductible : 0,
                        item.FMV
                    )
                } : newObj;
        });

        dispatch(bindMultiDonationOrderItems(newMultiOrderState));
        dispatch(bindMultiPayTotalTaxDeduct(
            newMultiOrderState && newMultiOrderState.reduce((k, el) => k + el.taxDeductible, 0)
        ));
        dispatch(bindDonationOrderItems({}));
    }, [
        multiDonationAmt,
        convFee,
        installments,
        isInstallmentTouched,
        IsInDefiniteRecurring,
        recurringPeriodicityEndDate,
        recurringMethods,
        IsConvFeeSelected,
        convfeeSelec.DefaultOpt,
        convfeeSelec.AddAdditionalFeeType,
        convfeeSelec.AdditionalFeePercentage,
        convfeeSelec.AdditionalFeeAmount,
        convfeeSelec.AdjustFee,
        recurringselection,
        meetformData.formdata,
        multiMinMaxErr,
        multiDonOrderItems,
        formSettings.Currency,
        formSettings.TaxDeductible,
        props.amountValidator,
        dispatch,
        t
    ]);

    const onBlurOtherHandler = useCallback(e => {
        const boostUpVals = JSON.parse(sessionStorage.getItem('boostUp'));
        const defaultOtherData = (amountButtonSection.DonationItemList || []).filter(
            arr => arr.DonationFor === 'Other' || arr.Type === 'Open'
        );
        const baseMin = defaultOtherData[0]?.MinValue ?? 0;
        const baseMax = defaultOtherData[0]?.MaxValue ?? 0;
        const minVal = boostUpVals && Object.keys(boostUpVals).length
            ? parseFloat(boostUpVals.minAmountVal) || parseFloat(baseMin) || 0
            : parseFloat(baseMin) || 0;
        const maxVal = boostUpVals && Object.keys(boostUpVals).length
            ? parseFloat(boostUpVals.maxAmountVal) || parseFloat(baseMax) || 0
            : parseFloat(baseMax) || 0;
        const numVal = parseFloat(e.target.value);

        if (!isNaN(numVal) && numVal > 0) {
            if (minVal > 0 && numVal < minVal) {
                dispatch(bindOtherAmountMinMaxError(true));
                setOtherMinMax(t('clickandpledge.minimumLimitIs', {
                    currency: formSettings.Currency,
                    value: minVal
                }));
            } else if (maxVal > 0 && numVal > maxVal) {
                dispatch(bindOtherAmountMinMaxError(true));
                setOtherMinMax(t('clickandpledge.maximumLimitIs', {
                    currency: formSettings.Currency,
                    value: maxVal
                }));
            } else {
                dispatch(bindOtherAmountMinMaxError(false));
                setOtherMinMax('');
            }
        } else if (e.target.value === '' || isNaN(numVal) || numVal <= 0) {
            dispatch(bindIsDonationAmountEmpty(true));
        }

        props.amountValidator.current.showMessageFor('other_amount');
    }, [ amountButtonSection.DonationItemList, formSettings.Currency, dispatch, props.amountValidator, t ]);

    const formInputWrapperStyle = { marginTop: '0.5rem' };
    const flexWrapStyle = {
        flexWrap: 'wrap',
        justifyContent: 'normal'
    };
    const alignCenterStyle = { alignItems: 'center' };
    const marginLeftStyle = { marginLeft: '45%' };
    const inputPaddingStyle = {
        padding: `0.48rem 0rem 0.48rem ${formSettings.Currency === '€' ? '2rem' : '3rem'}`,
        color: amountStyles?.color ? amountStyles?.color : '#ffffff'
    };

    return (
        <>
            <div
                className = 'form_input_wrapper'
                style = { formInputWrapperStyle }>
                {amountButtonSection.PaymentType === 'Single Payment' ? (
                    <div
                        className = { `recurring_btns_wrapper amount_btns_wrapper row-cols-${calculatedRowVal || 4}` }
                        style = { flexWrapStyle }>
                        {amountButtonSection.DonationItemList
                            && amountButtonSection.DonationItemList.map((item, index) => (
                                <div
                                    className = 'dw-col'
                                    key = { index }
                                    style = { amountStyles ? {
                                        '--borderColor': `${amountStyles['border-color']}`,
                                        '--color': `${amountStyles.color}`,
                                        '--bgColor': `${amountStyles['background-color']}`,
                                        '--fontWeight': `${amountStyles['font-weight']}`,
                                        '--bRadius': `${amountStyles['border-radius']}`,
                                        '--bhRadius': `${formSettings.AmountButtonSettings.AmountBtnMousehoverBorderRadius}px`,
                                        '--sborderColor': `${amountSelectedStyles['border-color']}`,
                                        '--scolor': `${amountSelectedStyles.color}`,
                                        '--sbgColor': `${amountSelectedStyles['background-color']}`
                                    } : null }>

                                    <button
                                        className = {
                                            item.DonationFor === 'Other' || item.Type === 'Open'
                                                ? `full_width section_btn ${amountStyles ? 'amountButtonSettings' : ''} ${
                                                    donationamount !== '' && (donationamount === -1 || (rValue && rValue.amountsection === -1))
                                                        ? 'selected'
                                                        : ''
                                                }`
                                                : `full_width section_btn ${amountStyles ? 'amountButtonSettings' : ''} ${
                                                    donationamount !== '' && donationamount !== -1 && (
                                                        donationIndex === null
                                                            ? item.DefaultValue !== undefined && String(donationamount) === String(item.DefaultValue)
                                                            : donationIndex.toString() === item.ItemID?.toString()
                                                    )
                                                        ? 'selected'
                                                        : ''
                                                }`
                                        }
                                        data-val = { item.DefaultValue }
                                        onClick = { () =>
                                            onDonationChange(
                                                item.DonationFor === 'Other' || item.Type === 'Open'
                                                    ? -1
                                                    : item.DefaultValue,
                                                index,
                                                item
                                            )
                                        }
                                        onMouseUp = { () =>
                                            props.amountValidator.current.showMessageFor(
                                                'amountsection'
                                            )
                                        }
                                        type = 'button'
                                        value = {
                                            item.DonationFor === 'Other' || item.Type === 'Open'
                                                ? -1
                                                : item.DefaultValue
                                        }>
                                        {item.DonationFor === 'Other' || item.Type === 'Open'
                                            ? t('clickandpledge.other')
                                            : formSettings.Currency + item.ItemAmount}
                                    </button>
                                </div>
                            ))}
                        {!props.isDonePayment
                            && props.amountValidator.current.message(
                                'amountsection',
                                rValue && rValue.amountsection,
                                'required',
                                { className: 'text-danger' }
                            )}
                    </div>
                ) : (
                    <>
                        {amountButtonSection.DonationItemList
                            && amountButtonSection.DonationItemList.map((item, index) => (
                                <React.Fragment key = { index }>
                                    <div
                                        className = 'form_input_wrapper form_input_wrapper_custom mt_075 d-flex justify-content-between'
                                        style = { alignCenterStyle }>
                                        <div className = 'w_50'>
                                            <label htmlFor = 'label'>
                                                {item.DonationFor ? item.DonationFor : item.ItemName}:
                                            </label>
                                        </div>
                                        <div className = ''>
                                            <input
                                                className = { `form-input numeric-input ${donationErr || (Object.keys(multiMinMaxErr).length
                                                    && Object.prototype.hasOwnProperty.call(
                                                        multiMinMaxErr,
                                                        `donation${index}`
                                                    )) ? 'input-error' : ''
                                                }` }
                                                id = { `label_one${index}` }
                                                name = { `donation${index}` }
                                                onBlur = { e => multiPaymentBlur(e, item) }
                                                onChange = { e => multiPaymentOnChange(e) }
                                                placeholder = '0.00'
                                                type = 'text'
                                                value = {
                                                    multiDonationVal[`donation${index}`]
                                                        ? multiDonationVal[`donation${index}`]
                                                        : ''
                                                } />
                                            {Object.keys(multiMinMaxErr).length
                                                && Object.prototype.hasOwnProperty.call(
                                                    multiMinMaxErr,
                                                    `donation${index}`
                                                )
                                                ? <div className = 'text-danger'>
                                                    {multiMinMaxErr[`donation${index}`]}
                                                </div> : null}
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))}

                        {donationErr && Object.keys(multiMinMaxErr).length === 0
                            && <div
                                className = 'text-danger'
                                style = { marginLeftStyle }>
                                {donationErr}
                            </div>}
                    </>
                )}

                {(rValue
                    && rValue.amountsection
                    && rValue.amountsection === -1
                    && donationamount !== '') || donationamount === -1 || showoneTimePayOption ? (
                        <>
                            <div
                                className = 'form_input_wrapper form_input_wrapper_custom d-flex justify-content-between'
                                style = { alignCenterStyle }>
                                <div className = ''>
                                    <label htmlFor = 'custom_amount'>
                                        {showoneTimePayOption ? t('clickandpledge.donationAmount') : t('clickandpledge.otherAmount')}
                                    </label>
                                </div>
                                <div className = ''>
                                    <div
                                        className = 'input_with_label'
                                        style = { amountStyles ? {
                                            '--borderColor': `${amountStyles['border-color']}`,
                                            '--color': `${amountStyles.color}`,
                                            '--bgColor': `${amountStyles['background-color']}`,
                                            '--fontWeight': `${amountStyles['font-weight']}`,
                                            '--bRadius': `${amountStyles['border-radius']}`,
                                            '--bhRadius': `${formSettings.AmountButtonSettings.AmountBtnMousehoverBorderRadius}px`
                                        } : null }>
                                        <input
                                            className = 'form-input required other_amount'
                                            id = 'custom_amount'
                                            maxLength = { 10 }
                                            name = 'cnp_zoom_formOtherAmount'
                                            onBlur = { e => onBlurOtherHandler(e) }
                                            onChange = { e => onOtherDonation(e) }
                                            style = { inputPaddingStyle }
                                            type = 'text'
                                            value = {
                                                donationamount === -1 ? '' : donationamount
                                            } />
                                        <span className = { `label ${amountStyles && 'amountButtonSettings'} ` }>
                                            {formSettings.Currency}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : null}
                {!props.isDonePayment && amountButtonSection.PaymentType === 'Single Payment'
                    && !otherMinMax
                    && props.amountValidator.current.message(
                        'other_amount',
                        donationamount === -1 ? '' : donationamount,
                        'required',
                        { className: 'text-danger' }
                    )}
                {!otherMinMax
                    && IsDonationAmountEmpty && <div className = 'text-danger'>Required</div>}
                {otherMinMax && <div className = 'text-danger'>{otherMinMax}</div>}
                {finalDonationAmountError
                    && <div className = 'text-danger'>
                        {t('clickandpledge.amountCannotBeLessThan', { currency: formSettings.Currency })}
                    </div>}
            </div>
        </>
    );
};

export default translate(DonationsButton);
